import { H1 } from '@/components/Headings';
import Socials from '@/components/Socials';
import { TextDefault } from '@/components/Texts';
import { colors } from '@/styles/theme/colors';
import { outerLinks } from '@/utils/constants/outer-links';
import { Flex, Stack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

const ContactUsHero = () => {
  const { t } = useTranslation('main');

  return (
    <Stack
      align={{ base: 'center', lg: 'start' }}
      textAlign={{ base: 'center', lg: 'start' }}
      spacing={12}
      color={colors.diment.darkBlue}
    >
      <Stack maxW={'lg'}>
        <H1>{t('contact-us.hero.heading')}</H1>
        <TextDefault fontWeight={500}>
          {t('contact-us.hero.description')}
        </TextDefault>
      </Stack>
      <Stack spacing={4} maxW={500}>
        <TextDefault fontWeight={800} fontSize={'2xl'}>
          Diment
        </TextDefault>
        {/* <TextDefault fontWeight={500}>
          First Floor Almas Tower, Jumeirah Lakes Towers, PO Box 371653 Dubai,
          United Arab Emirates
        </TextDefault> */}
        <Flex
          justify={{ base: 'center', lg: 'start' }}
          fontWeight={800}
          gap={8}
          wrap={'wrap'}
        >
          <Link href={outerLinks.socials.supportEmail}>support@diment.io</Link>
          {/* <Link href={'tel:+97142391555'}>+97 142 391 555</Link> */}
        </Flex>
      </Stack>
      <Socials color={colors.diment.darkBlue} bg='rgba(255, 255, 255, 0.5)' />
    </Stack>
  );
};

export default ContactUsHero;
